import * as React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { LoginRoute } from '~/Application/routes';
import { ErrorConsumer } from '~/ErrorHandler';
import { Setup } from '~/Password';
import { useSearchParams } from '~/Router/useSearchParams';
import { ErrorAlert } from '~/UI';
export var PasswordSetup = function (_a) {
    var title = _a.title;
    var searchParams = useSearchParams();
    var token = searchParams.get('token');
    var userId = searchParams.get('user');
    var redirectToLogin = LoginRoute.useRedirect();
    if (token === null || userId === null) {
        return <LoginRoute.Redirect />;
    }
    return (<Grid style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }} textAlign='left'>
				<Header>{title}</Header>
				<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
				<Setup token={token} userId={userId} onComplete={function () {
            redirectToLogin({});
        }}/>
			</Grid.Column>
		</Grid>);
};
PasswordSetup.displayName = 'Application.PasswordSetup';
